import env from '@beam-australia/react-env';
import { call, all } from 'redux-saga/effects';
import { linkPrefixes, locationInputs } from '@/constants/urls';
import { hasMinimumLength, stringToCheck } from './resultsHelper';
import { responseError } from './errors';

const callAdapter = (serviceCall) => serviceCall
  .then((response) => ({ response }))
  .catch((error) => ({ error }));

export const batchAdapter = (item, promise, additional = {}) => (
  promise.then((response) => (response)).catch((error) => ({ ...item, ...additional, error }))
);

export const callAdapterResponseError = (item, promise) => (
  promise.then(() => ({ ...item })).catch((error) => ({ ...item, error: responseError({ error }) }))
);

const allowedFrameAncestors = () => stringToCheck(env('ALLOWED_FRAME_ANCESTORS')).split(' ').filter(
  (o) => hasMinimumLength(o),
).map((o) => `${linkPrefixes.HTTPS}${o}`.toLowerCase());

export function* postMessage(action) {
  const inFrame = locationInputs.inFrame();
  const origins = inFrame ? Array.from(new Set(allowedFrameAncestors())) : [];

  if (inFrame && origins.length > 0) {
    yield all(origins.map((o) => call(locationInputs.postMessage, { ...action, source: 'FAIR' }, o)));
  }
}

export default callAdapter;
